import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from "react-router-dom";
import ApiClient from "../methods/api/apiClient";
import loader from '../methods/loader';
import { MdOutlineEmail } from 'react-icons/md';
import { GoHistory } from "react-icons/go";
import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { LuUser, LuUserPlus } from 'react-icons/lu';
import { MdClear } from "react-icons/md";
import axios from 'axios';
import { TbFileExport } from "react-icons/tb";
import environment from '../environment';
import Modal from "../components/common/Modal";
import AddNewGroup from './Events/AddNewGroup';
import { IoMdClose, IoMdCloudDownload, IoMdCloudUpload } from 'react-icons/io';
import { FiPlus, FiTrash } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import PageLayout from '../components/global/PageLayout';
import { toast } from 'react-toastify';
import datepipeModel from '../models/datepipemodel';
import GroupHistory from "./GroupHistory"
import { useSelector } from "react-redux";
import { BsCheck, BsCrosshair } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import { Tooltip } from 'antd';
import { decryptId } from '../components/common/Encryption/encryption';

const Groups = ({ eventDetail = '', dataa = '', stateData = "" }) => {
    
    const { eventid } = useParams()
    const [id, setId] = useState(null);
    useEffect(() => {
        if (eventid) {
            decryptId(eventid).then(decrypted => setId(decrypted));
        }
    }, [eventid]);
    const location = useLocation();
    const history = useNavigate();
    const user = useSelector((state) => state.user);
    const receivedStateData = location.state;
    const [groupList, setGroupList] = useState()
    const [attendeesGroup, setattendeesGroup] = useState()
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [requestGroup, setRequestGroup] = useState(false)
    const [requestGroupList, setRequestGroupList] = useState("")
    const [historyData, setHistoryData] = useState()
    const [openHistoryData, setOpenHistoryData] = useState(false)
    const [historyModal, setHistoryModal] = useState(false)
    const [data, setData] = useState()
    const [showDiv, setShowDiv] = useState(false)
    const eventIdd = receivedStateData?.eventId?.id
    const groupId = receivedStateData?.dataa?.data?.groupId?._id || receivedStateData?.groupId?._id

    // cw: Look up user's role in THIS event's group, not lastUsedGroupId
    const eventGroupEntry = user?.groups?.find(g => {
        const gid = g.groupId?._id || g.groupId;
        return gid?.toString() === groupId?.toString() && g.status === 'active';
    });
    const eventRoleId = eventGroupEntry?.customerRole?._id || eventGroupEntry?.customerRole;
    const eventGroupData = receivedStateData?.dataa?.data?.groupId || receivedStateData?.groupId;
    const connectMeetLabel = eventGroupData?.connectMeetLabel || user?.connectMeetLabel || 'ConnectMeet';
    const canManageGroups = environment.groupLeaderRoleIds.includes(eventRoleId) || eventRoleId === environment.connectmeetmanagerRoleId;
    const [lateArrivals, setLateArrivals] = useState([])

    const handleCloseModal = () => {
        setShowDiv(false)
    }
    const importFile = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (event) => {
                const base64String = event.target.result;

                let payload = {
                    groupId: groupId,
                    eventId: eventIdd,
                    base64String: base64String
                };

                ApiClient.post(`api/import/event-group`, payload).then(res => {
                    if (res.success) {
                        toast.success(res.message);
                    }
                });
            };

            reader.readAsDataURL(file);
        }
    };

    const handleSelectValue = (e, element) => {
        loader(true)
        const selectedValue = e?.target?.value;
        
        // Check if moving to "Group Assignment Declined" (Not_interested)
        const selectedOption = transformedArray?.find(t => String(t._id) === String(selectedValue));
        const isNoGroup = selectedOption?.isNoGroup || selectedValue === 'no_group';
        
        let payload = {
            data: [{
                id: element?.id,
                ConnectMeetId: isNoGroup ? null : selectedValue,
                groupNo: isNoGroup ? 'Not_interested' : undefined,
                attendeeId: element?.attendeesDetails?._id,
                eventId: element?.attendeesDetails?.eventId,
                groupId: element?.attendeesDetails?.groupId
            }]
        };
        
        
        ApiClient.put('api/event/group/edit', payload).then(res => {
            loader(false)
            if (res.success) {
                toast.success(res.message)
                e.target.value = "";
                getGroupPair()
                
                // cw: refresh emailcombinations in db after moving someone to a diff connectmeet group
                ApiClient.post('api/refresh-combinations', { eventId: eventIdd }).then(() => {
                });
            }
        })
    }

    // cw: if attendee is checked in AFTER generate connectmeets happened, add them to late group
    const getGroupPair = () => {
        return ApiClient.get(`api/event/group/list?eventId=${eventIdd}`).then(res => {
            if (res.success) {
                const sorted = res?.data?.sort((a, b) => a._id.ConnectMeetId - b._id.ConnectMeetId);
                setGroupList(sorted)
                
                // Get all attendee IDs that are already in groups
                const attendeesInGroups = new Set()
                sorted?.forEach(group => {
                    group?.attendees?.forEach(att => {
                        if (att?.attendeesDetails?._id) {
                            attendeesInGroups.add(att.attendeesDetails._id.toString())
                        }
                        if (att?.attendeeId) {
                            attendeesInGroups.add(att.attendeeId.toString())
                        }
                    })
                })
                
                // Fetch late arrivals after we have the groups
                getLateArrivals(attendeesInGroups)
            }
        })
    }
    
    const getLateArrivals = (attendeesInGroups) => {
        if (!attendeesInGroups) {
            setLateArrivals([])
            return
        }
        
        ApiClient.get(`api/attendees/list?eventId=${eventIdd}`).then(res => {
            if (res.success) {
                // Filter to only those checked in but not in any group
                const late = res.data.filter(att => {
                    const attId = att._id?.toString() || att.id?.toString()
                    const isInGroup = attendeesInGroups.has(attId)
                    const isCheckedIn = att.isPresent === true
                    
                    return isCheckedIn && !isInGroup
                })
                setLateArrivals(late)
            }
        })
    }
    const getGroupRequest = () => {
        let payload = {
            eventId: eventIdd
        }
        return ApiClient.get(`api/group-request/list`, payload).then(res => {
            if (res.success) {
                setRequestGroupList(res?.data)
            }
        })
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scrolling
        });
    };
    const getGroupExport = async () => {
        try {
            const res = await axios({
                method: "get",
                url: `${environment.api}api/export/event-group?eventId=${eventIdd}`,
            });
            
            // Decode base64 to binary
            const binaryString = atob(res.data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            
            const blob = new Blob([bytes], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            
            let downloadAnchor = document.createElement("a");
            downloadAnchor.href = window.URL.createObjectURL(blob);
            const evtTitle = (groupList?.[0]?.eventsDetails?.title || 'GroupsDetail').replace(/[^a-zA-Z0-9 ]/g, '').trim();
            const evt = groupList?.[0]?.eventsDetails;
            const evtDate = evt?.date ? new Date(evt.date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-') : '';
            let evtTime = '';
            if (evt?.date) {
              const d = new Date(evt.date);
              const tz = evt.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
              const timeParts = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz }).replace(/\s/g, '');
              const tzAbbr = new Date('2020-01-15T12:00:00Z').toLocaleTimeString('en-US', { timeZoneName: 'short', timeZone: tz }).split(' ').pop();
              evtTime = `_${timeParts}${tzAbbr}`;
            }
            downloadAnchor.download = `${evtTitle}${evtDate ? '_' + evtDate : ''}${evtTime}.xlsx`;
            downloadAnchor.click();
        } catch (error) {
            if (error.response?.data) {
                console.error('Export error:', error.response.data);
            }
            toast.error('Export failed');
        }
    };

    useEffect(() => {
        getGroupPair()
        getGroupRequest()
        scrollToTop();
    }, [])
    const handleInputField = async () => {
        try {

            const res = await axios({
                method: "get",
                url: `${environment.api}api/sample/group-import`,
                responseType: 'blob',

            });
            var blob = new Blob([res.data], {
                type: res.headers["content-type"],
            });
            let downloadAnchor = document.createElement("a")
            downloadAnchor.href = window.URL.createObjectURL(blob);
            downloadAnchor.download = `SampleFile.xlsx`;
            downloadAnchor.click()


        } catch (error) {
            console.error('Error fetching data:', error);
        }


    };

    // const handleCheckboxClick = (e, email) => {
    //     if (e.target.checked) {
    //         setSelectedEmails(prevSelectedEmails => [...prevSelectedEmails, email]);
    //     } else {
    //         setSelectedEmails(prevSelectedEmails => prevSelectedEmails.filter(selectedEmail => selectedEmail !== email));
    //     }
    // };
    const [selectedAttendee, setSelectedAttendee] = useState(null);
    const [selectedName, setSelectedName] = useState(null);
    const handleCheckboxClick = (e, targetUserId, name) => {

        if (e.target.checked) {
            setSelectedName(name)
            setSelectedAttendee(targetUserId)
            setHistoryData(null)
            setHistoryModal(true)
            loader(true)
            ApiClient.get(`api/user/historic/data?userId=${targetUserId}&groupId=${user?.groupId?._id}&eventId=${id}`).then(res => {
                loader(false)
                if (res.success) {
                    setHistoryData(res?.data)
                }
            })
        }
    };

    const getInvites = () => {
        loader(true)
        let f = {
            eventId: receivedStateData?.eventId?.id,
            groupId: groupId,
            groupNo: "",
            attendeeIds: [

            ]
        }
        ApiClient.post('api/add/group-event', f).then(res => {
            loader(false)
            if (res.success) {
                toast.success(res.message)
                getGroupPair()
            } else {
                console.error("Add failed:", res);
                toast.error(res.message || 'Failed to add group')
            }
        })
    }
    const handleSelectAllClick = (e, attendees) => {
        const emails = attendees?.map(attendee => attendee?.attendeesDetails?.email);
        if (e?.target?.checked) {
            setSelectedEmails(prevSelectedEmails => [...prevSelectedEmails, ...emails]);
            // setHistoryModal(true)
        } else {
            setSelectedEmails(prevSelectedEmails => prevSelectedEmails.filter(selectedEmail => !emails.includes(selectedEmail)));
        }
    };
    // const getselectedEmailsData = () => {

    //     const emails = selectedEmails.join(',');
    //     loader(true)
    //     ApiClient.get(`api/user/historic/data?email=${emails}`).then(res => {
    //         if (res.success) {
    //             setHistoryData(res?.data)
    //             loader(false)
    //         }
    //     })
    // }
        const handleDeleteIcon = (ele) => {
            const eventIdToDelete = ele?._id?.eventId || eventIdd;
            const connectMeetIdToDelete = ele?._id?.ConnectMeetId;
            
            
            if (!eventIdToDelete || connectMeetIdToDelete === undefined || connectMeetIdToDelete === null) {
                toast.error('Cannot delete: missing group information');
                return;
            }
            
            loader(true)
            ApiClient.delete(`api/group-event/remove?eventId=${eventIdToDelete}&connectMeetId=${connectMeetIdToDelete}`)
            .then(res => {
                loader(false)
                if (res.success) {
                    toast.success(res.message)
                    getGroupPair()
                } else {
                    console.error("Delete failed:", res);
                    toast.error(res.message || 'Failed to delete group')
                }
            })
            .catch(err => {
                loader(false)
                console.error("Delete error:", err.response?.data);
                toast.error(err.response?.data?.message || 'Delete failed')
            })
    }

    const sendGroupMail = () => {
        loader(true)
        let payload = {
            eventId: id,
            groupId: receivedStateData?.groupId?._id || receivedStateData?.dataa?.data?.groupId?._id || user?.groupId?._id
        }
    
        if (!payload.groupId) {
            toast.error("Group ID is missing");
            loader(false);
            return;
        }
        ApiClient.post(`api/send-email/event-group`, payload).then(res => {
            if (res.success) {
                loader(false)
                toast.success(res.message)

            }
        })
    }
    const handleclose = () => {
        setOpenHistoryData(false)
        setSelectedAttendee(null)
    }
    const [transformedArray, setTransformedArray] = useState([]);
    const [draggedElement, setDraggedElement] = useState(null);
    const [dragOverGroup, setDragOverGroup] = useState(null);

    const handleDragStart = (e, element, sourceGroup) => {
        setDraggedElement({ element, sourceGroup });
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e, targetGroupId) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverGroup(targetGroupId);
    };

    const handleDragLeave = () => {
        setDragOverGroup(null);
    };

    const handleDrop = (e, targetGroup) => {
        e.preventDefault();
        setDragOverGroup(null);
        if (!draggedElement) return;

        const { element, sourceGroup } = draggedElement;
        const targetIsDeclined = targetGroup?.groupNo === "Not_interested";
        const sourceIsDeclined = sourceGroup?.groupNo === "Not_interested";
        const targetConnectMeetId = targetIsDeclined ? null : targetGroup?._id?.ConnectMeetId;
        const sourceConnectMeetId = sourceIsDeclined ? null : sourceGroup?._id?.ConnectMeetId;

        // Don't drop on same group
        if (targetIsDeclined && sourceIsDeclined) return;
        if (!targetIsDeclined && !sourceIsDeclined && targetConnectMeetId === sourceConnectMeetId) return;

        loader(true);
        let payload = {
            data: [{
                id: element?.id,
                ConnectMeetId: targetIsDeclined ? null : targetConnectMeetId,
                groupNo: targetIsDeclined ? 'Not_interested' : undefined,
                attendeeId: element?.attendeesDetails?._id,
                eventId: element?.attendeesDetails?.eventId,
                groupId: element?.attendeesDetails?.groupId
            }]
        };

        ApiClient.put('api/event/group/edit', payload).then(res => {
            loader(false);
            if (res.success) {
                toast.success(res.message);
                getGroupPair();
                ApiClient.post('api/refresh-combinations', { eventId: eventIdd }).then(() => {
                });
            }
        });

        setDraggedElement(null);
    };

    const handleDragEnd = () => {
        setDraggedElement(null);
        setDragOverGroup(null);
    };

    const transformAndSetState = (list) => {
        const filteredList = list?.filter(item => item?.groupNo !== "Not_interested") || [];
        const transformedArray = filteredList.map((item, index) => ({
            _id: item._id?.ConnectMeetId,
            name: index + 1,  // cw: use sequential numbering for display
            originalGroupNo: item?.groupNo  // keep original for reference
        }));
        
        // cw: ALWAYS add "Group Assignment Declined" option (maps to Not_interested)
        // This allows moving people to declined even if nobody is there yet
        transformedArray.unshift({
            _id: 'no_group',  // Special value since ConnectMeetId is null
            name: 'Group Assignment Declined',
            originalGroupNo: 'Not_interested',
            isNoGroup: true
        });
        
        setTransformedArray(transformedArray);
    };
    useEffect(() => {
        transformAndSetState(groupList);
    }, [groupList]);

    return (
        <>



            <PageLayout>

                <div className="bg-white border-gray-200 px-4 pt-8 lg:px-6 py-2.5 dark:bg-gray-800">
                    <div className="container mx-auto">
                        <div
                            className="mb-4 pt-1  pointer"
                            onClick={() => history(-1)}
                        >
                            <span>


                                <i className="fa fa-arrow-left mr-2"></i>
                            </span>
                            Back
                        </div>
                        {/* <div>
                            <h4>{groupList[0]?.eventsDetails?.title}</h4>
                            <p> {datepipeModel.datetime(groupList[0]?.eventsDetails?.date)}</p>
                        </div> */}
                        {/* <buuton onClick={getselectedEmailsData}>Search</buuton> */}
                        <div className=''>
                            <div className='flex items-center gap-4  mb-3'>

                                <div className='flex items-center justify-between flex-wrap w-full'>
                                    <div className='mt-2 flex items-center gap-2'>
                                        {canManageGroups && (
                                            <div className=''>
                                                <button className='w-full text-sm bg-orange-500 rounded-lg px-1 lg:px-4 py-2 text-white flex items-center gap-4 justify-center font-bold' onClick={getInvites}>
                                                    + Add New Group
                                                </button>
                                            </div>
                                        )}
                                        {canManageGroups && (
                                        <div className=''>
                                        <button className='w-full text-sm bg-[#393c3d] rounded-lg px-4 py-2 text-white flex items-center gap-4 justify-center font-bold' onClick={() => setShowDiv(true)}><LuUserPlus /> {connectMeetLabel} Requests</button>
                                        </div>
                                        )}
                                    </div>
                                    <div className='flex items-center gap-2 flex-wrap'>


                                        {/* <div className=''> 
                                            <div className="flex  items-center justify-center bg-grey-lighter">
                                                <label className=" flex gap-2 items-center border-dashed border-gray-200 items-center px-2 py-2 bg-white text-blue rounded-lg tracking-wide  border border-blue cursor-pointer ">
                                                    <IoMdCloudDownload className='text-md' />

                                                    <span className="text-sm leading-normal" onClick={() => handleInputField()}>Sample file download </span>

                                                </label>
                                            </div>
                                        </div> */}
                                        <button className='bg-orange-500 px-2 py-2 rounded-md text-sm flex items-center gap-2 text-white' onClick={getGroupExport}><TbFileExport className='text-md' /> Export Data</button>
                                        {canManageGroups && (
                                        <button className='bg-[#393c3d] px-2 py-2 rounded-md text-sm flex items-center gap-2 text-white' onClick={sendGroupMail}><MdOutlineEmail className='text-md' /> Send Grouping Emails</button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {showDiv ? <div className='w-full border border-1 mt-4 rounded-lg p-3 mb-4'>
                                <div className="flex items-center justify-end">
                                    <button className='bg-orange-500 text-sm px-2 py-1 flex items-center gap-1 rounded-md text-white' onClick={handleCloseModal}><MdClear />  Close</button>
                                </div>
                                <div className='grid grid-cols-1 lg:grid-cols-2'>
                                {requestGroupList?.filter(r => r?.requestType !== 'system_generate')?.length ? requestGroupList?.filter(r => r?.requestType !== 'system_generate')?.map((ele) => {
                                    return (<><div className="shwoing-requeted">
                                        <h4 className='mb-4 mt-4 text-xs'>Requested By : <span className='bg-orange-500 px-2 py-1 pb-1 text-sm rounded-md ml-2 text-white'>{ele?.requestedByDetails?.fullName ? `${ele.requestedByDetails.fullName} (${ele?.requestedBy})` : ele?.requestedBy}</span></h4>

                                        {ele?.requestType === "not_interested" ? (
                                            <div className='p-3 bg-red-50 border border-red-200 rounded-md'>
                                                <span className='text-red-600 font-medium'>Not available for {connectMeetLabel} this event</span>
                                            </div>
                                        ) : ele?.requestType === "system_generate" ? (
                                            <div className='p-3 bg-green-50 border border-green-200 rounded-md'>
                                                <span className='text-green-600 font-medium'>Available for {connectMeetLabel} (system will assign)</span>
                                            </div>
                                        ) : ele?.attendeesDetails?.filter(a => a?.fullName || a?.email)?.length > 0 ? (
                                            <table className='w-full'>
                                                <thead className='border border-gray-200'>
                                                    <tr className='border border-gray-200'>
                                                        <th className='border border-gray-200 text-left p-2'>Name</th>
                                                        <th className='border border-gray-200 text-left p-2'>Email</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ele?.attendeesDetails?.filter(a => a?.fullName || a?.email)?.map((element, idx) => {
                                                        return (<tr key={idx}>
                                                            <td className='border border-gray-200 p-2 capitalize'>{element?.fullName}</td>
                                                            <td className='border border-gray-200 p-2'>{element?.email}</td>
                                                        </tr>)
                                                    })}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className='p-3 bg-gray-50 border border-gray-200 rounded-md'>
                                                <span className='text-gray-500'>No specific members requested</span>
                                            </div>
                                        )}
                                    </div></>)
                                }) : "No Request Available"}
                                </div>

                            </div> : ""}
                            {/* cw: late Arrivals Box - only visible to GL and CMM */}
                            {canManageGroups &&
                            lateArrivals.length > 0 && (
                                <div className='w-full border-2 border-orange-500 mt-4 rounded-lg p-3 mb-4 bg-orange-50'>
                                    <div className="flex items-center justify-between mb-3">
                                        <h3 className='font-bold text-orange-600 text-lg flex items-center gap-2'>
                                            <LuUserPlus /> Late Arrivals ({lateArrivals.length})
                                        </h3>
                                    </div>
                                    <p className='text-sm text-gray-600 mb-3'>These attendees checked in after groups were generated.</p>
                                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2'>
                                        {lateArrivals.map((attendee, index) => (
                                            <div key={index} className='border border-gray-200 rounded-lg p-3 bg-white flex items-center justify-between'>
                                                <div>
                                                    <p className='font-medium capitalize'>{attendee.memberDetails?.fullName || attendee.fullName}</p>
                                                    <p className='text-sm text-gray-500'>{attendee.email || attendee.memberDetails?.email}</p>
                                                </div>
                                                <div className='rounded-md shadow-md bg-orange-400 px-2 pb-1'>
                                                    <select 
                                                        className="bg-transparent focus:outline-none cursor-pointer text-[14px] text-white"
                                                        value=""
                                                        onChange={(e) => {
                                                            if (e.target.value) {
                                                                loader(true)
                                                                const selectedConnectMeetId = e.target.value;
                                                                
                                                                
                                                                // Find the target group to get its groupNo
                                                                const targetGroup = groupList?.find(g => 
                                                                    g._id?.ConnectMeetId?.toString() === selectedConnectMeetId
                                                                );
                                                                
                                                                
                                                                let payload = {
                                                                    eventId: eventIdd,
                                                                    groupId: groupId,
                                                                    attendeeIds: [attendee._id || attendee.id],
                                                                    ConnectMeetId: parseInt(selectedConnectMeetId),
                                                                    groupNo: targetGroup?.groupNo || targetGroup?._id?.groupNo
                                                                };
                                                                
                                                                
                                                                ApiClient.post('api/add/group-event', payload).then(res => {
                                                                    loader(false)
                                                                    if (res.success) {
                                                                        toast.success('Attendee added to group')
                                                                        getGroupPair()
                                                                    } else {
                                                                        toast.error(res.message || 'Failed to add attendee')
                                                                    }
                                                                })
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Move to</option>
                                                        {transformedArray?.filter(d => !d.isNoGroup).map((data, idx) => (
                                                            <option key={idx} className='text-md text-black' value={data?._id}>
                                                                Group {data.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className='grid grid-cols-12 gap-x-4'>
                                <div className={`${openHistoryData ? "col-span-12 md:col-span-7" : "col-span-12"}`} >
                                    <div className='grid grid-cols-1 lg:grid-cols-2  gap-2'>
                                        {groupList?.map((ele, index) => {
                                            //console.log(`Frontend Group ${index + 1}: ConnectMeetId=${ele?._id?.ConnectMeetId}`);
                                            return (
                                                <>

                                                    <div
                                                        className={`brouplists border border-1 rounded-lg shadow-lg p-3 mb-3 transition-colors ${dragOverGroup === (ele?.groupNo === "Not_interested" ? "declined" : ele?._id?.ConnectMeetId) ? 'border-orange-500 bg-orange-50' : ''}`}
                                                        onDragOver={(e) => handleDragOver(e, ele?.groupNo === "Not_interested" ? "declined" : ele?._id?.ConnectMeetId)}
                                                        onDragLeave={handleDragLeave}
                                                        onDrop={(e) => handleDrop(e, ele)}
                                                    >


                                                        <div className='flex items-center justify-between border-b border-1 pb-2 mb-2'>
                                                            <div className='flex items-center gap-1'>
                                                                {/* { ele?.attendees ?  <input type="checkbox" onChange={(e) => handleSelectAllClick(e, ele?.attendees)} /> :""}  */}
                                                                {ele?.groupNo === "Not_interested" ? <h2 className='font-bold text-[#2b2b2b] text-lg'> Group Assignment Declined</h2> : <h2 className='font-bold text-[#2b2b2b] text-lg'> {`Group ${groupList?.filter(g => g?.groupNo !== "Not_interested").indexOf(ele) + 1}`}
                                                                    {/* {ele?._id?.ConnectMeetId} */}

                                                                </h2>}
                                                            </div>
                                                            {/* {ele?.isRandomGroup === false && ele?.attendees?.length < 0 ? <div >
                                                                <FaTrashAlt onClick={() => handleDeleteIcon(ele)} />

                                                            </div> : ""}  */}

                                                            {canManageGroups &&
                                                                ele?.isRandomGroup === false &&
                                                                Array.isArray(ele?.attendees) && 
                                                                ele.attendees.length >= 0 ? (
                                                                <div>
                                                                    <FaTrashAlt onClick={() => handleDeleteIcon(ele)} />
                                                                </div>
                                                                ) : null}

                                                            {/* {ele?.isUnique === true ? <span className='bg-orange-500 p-2 text-xs  mb-0 text-white rounded-md inline-flex'>New Pair</span> : ""} */}
                                                        </div>
                                                        <p className=''>{ele?.attendees?.map((element) => {
                                                            return (
                                                                <div
                                                                    className={`card_inners border-b last:border-0 flex gap-y-2 items-center justify-between p-2 ${canManageGroups && data?.status !== 'ended' && data?.status !== 'completed' ? 'cursor-grab active:cursor-grabbing' : ''}`}
                                                                    draggable={canManageGroups === true && data?.status !== 'ended' && data?.status !== 'completed'}
                                                                    onDragStart={(e) => handleDragStart(e, element, ele)}
                                                                    onDragEnd={handleDragEnd}
                                                                >
                                                                    <div className='flex items-start gap-1'>
                                                                        {element?.attendeesDetails?.email && ele?.groupNo != "Not_interested" ? <button
                                                                            type="button"
                                                                            className='mt-1 cursor-pointer text-gray-500 hover:text-orange-500 shrink-0'
                                                                            title="View history"
                                                                            onMouseDown={(e) => e.stopPropagation()}
                                                                            onClick={(e) => { e.stopPropagation(); handleCheckboxClick({ target: { checked: true } }, element?.attendeesDetails?.userId, element?.attendeesDetails?.fullName); }}
                                                                        ><GoHistory className='text-[16px]' /></button> : ""}
                                                                        <div>
                                                                            {element?.attendeesDetails?.fullName ? <p className='flex items-center mb-2 gap-1 text-[#75757A] text-[14px] capitalize'><LuUser className='text-black !text-[16px]' />{element?.attendeesDetails?.fullName}</p> : ""}
                                                                            {element?.attendeesDetails?.email ? <p className='flex items-center gap-1 text-[#75757A]  text-[14px]'><MdOutlineEmail className='text-black !text-[16px]' />{element?.attendeesDetails?.email}</p> : ""}

                                                                        </div>
                                                                    </div>
                                                                    {element?.attendeesDetails?.fullName || element?.attendeesDetails?.email ?
                                                                    <div className='shrink-0'>
                                                                        {canManageGroups === true &&
                                                                            data?.status !== 'ended' &&  
                                                                                data?.status !== 'completed' && (
                                                                                    <div className='rounded-md shadow-md bg-orange-400 focus:outline-none cursor-pointer px-2 pb-1'>
                                                                            <select className="bg-transparent focus:outline-none cursor-pointer text-[14px] text-white w-[100px]" onChange={(e) => handleSelectValue(e, element)}>
                                                                                <option value="" disabled selected>Move to</option>
                                                                                {transformedArray?.map((data, index) => {
                                                                                    // Don't show current group as an option
                                                                                    // For Not_interested group, hide the "Group Assignment Declined" option
                                                                                    const isCurrentGroup = ele?.groupNo === "Not_interested" 
                                                                                        ? data.isNoGroup 
                                                                                        : data._id === ele._id?.ConnectMeetId;
                                                                                    
                                                                                    if (isCurrentGroup) return null;
                                                                                    
                                                                                    return (
                                                                                        <option key={index} className='text-md text-black' value={data?._id}>
                                                                                            {data.isNoGroup ? 'Group Assignment Declined' : `Group ${data.name}`}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>

                                                                        </div>)}

                                                                        </div>

                                                                        : ""}

                                                                </div>

                                                            )
                                                        })}</p>
                                                    </div>
                                                </>
                                            )

                                        })}
                                    </div>

                                </div>


                                {openHistoryData ? <div className='col-span-12 md:col-span-5'>
                                    <div className='histroy_showinf p-4 rounded-md border border-gray-300 '>

                                        <div className='flex items-center justify-between mb-4'>

                                            <h6 className='text-black text-xl flex items-center gap-2 '> <GoHistory /> <span>{selectedName}</span> History </h6>
                                            <button className='cursor-pointer ' onClick={handleclose}><Tooltip title="Close" placement='top' ><span><IoMdClose /></span></Tooltip></button>
                                        </div>



                                        {historyData === null ? <p className="text-gray-400 text-sm">Loading...</p> : historyData?.length ? <div className='grid grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-4'>

                                            {historyData?.map((ele) => {
                                                return (<div className="w-full ">
                                                    <div className=" border border-gray-200 rounded-lg">
                                                        <Disclosure >
                                                            {({ open }) => (
                                                                <>
                                                                    <Disclosure.Button className="flex w-full items-center cursor-pointer justify-between rounded-lg bg-orange-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-orange-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                                                                        <div className=' '>

                                                                            <div className='flex flex-col gap-y-1'>
                                                                                <h4 className='text-sm font-semibold text-[#2b2b2b] break-all capitalize'>{ele?.eventsDetails?.[0]?.title} </h4>
                                                                                <h4 className='text-xs font-normal text-[#2b2b2b] break-all capitalize'>{ele?.eventsDetails?.[0]?.date ? datepipeModel.datetime(ele?.eventsDetails?.[0]?.date) : ""}</h4>
                                                                                {/* <p className='text-xs text-gray-500'>{ele?.ConnectMeetId}</p> */}
                                                                            </div>
                                                                        </div>
                                                                        <ChevronUpIcon
                                                                            className={`${open ? 'rotate-180 transform' : ''
                                                                                } h-5 w-5 text-black`}
                                                                        />
                                                                    </Disclosure.Button>
                                                                    <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
                                                                        {ele?.membersDetails?.map((element) => {
                                                                            return (
                                                                                <div className=''>
                                                                                    <p className='flex items-center mb-2 gap-1 text-[#75757A] text-[12px] xl:text-[14px] break-all capitalize'><LuUser className='text-black !text-[16px]' />{element?.fullName}</p>
                                                                                    <p className='flex items-center mb-2 gap-1 text-[#75757A] text-[12px] xl:text-[14px] break-all '><MdOutlineEmail className='text-black !text-[16px]' />{element?.email}</p>
                                                                                </div>
                                                                            )
                                                                        })}

                                                                    </Disclosure.Panel>
                                                                </>
                                                            )}
                                                        </Disclosure>



                                                        <div></div>
                                                    </div>
                                                </div>)
                                            })}
                                        </div> : `No History Available For Past ${localStorage.getItem("connectMeetHistory") || 6} Months`}



                                    </div>

                                </div> : ""}




                            </div>


                        </div>

                        {/* {Object.entries(eventDetail).map(([group, items] :any) => (
                <div key={group}>
                    <p>{group}</p>
                    {items?.map((item) => (
                        <div key={item.id} style={{ display: "flex", justifyContent: "space-evenly" }}>
                            <p className="capitalize">{item.fullName}</p>
                            <p>{item.email}</p>
                            <select className="form-select" onChange={handleSelectValue}>
                                <option value="" disabled selected>Move to</option>
                                <option value="group1">1</option>
                                <option value="group2">2</option>
                                <option value="group3">3</option>
                                <option value="group4">4</option>
                            </select>
                        </div>
                    ))}
                </div>
            ))} */}
                        {requestGroup ? <>
                            <Modal

                                title="Request Group"
                                body={<>
                                    <AddNewGroup dataaa={receivedStateData?.dataa} setRequestGroup={setRequestGroup} getGroupPair={getGroupPair} receivedStateData={receivedStateData} />
                                </>}
                                result={e => {
                                    setRequestGroup(false)
                                }}
                            />
                        </> : <></>}
                        {historyModal ? <>
                            <Modal

                                title={`${selectedName || ''} History`}
                                body={<>
                                    <GroupHistory data={historyData} />
                                </>}
                                result={e => {
                                    setHistoryModal(false)
                                    setSelectedAttendee(null)
                                }}
                            />
                        </> : <></>}
                    </div>
                </div>

            </PageLayout>
        </>


    )
}

export default Groups